<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Product categories</h5>
    <div class="widget-category-list mt-20">
      <div 
        class="single-widget-category pointer" 
        v-for="c in categoryData" 
        :key="c.cat_id" 
      >
        <input 
          type="checkbox" 
          :id="`cat-item-${c.cat_id}`" 
          :class="activeQuery === c.cat_name ? 'checked' : ''"
        >
        <label 
          @click="handleCategoryRoute(c.cat_name)" 
          :for="`cat-item-${c.cat_id}`" 
          class="pointer"
        >
          {{ c.cat_name }} <span>({{ c.product_count || 0 }})</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { formatUrl } from "@/utils/utils";

export default {
  name: "ProductCategories",
  data() {
    return {
      categoryData: [], // Initialize as an empty array
      activeQuery: "",
    };
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        this.activeQuery = newQuery.category;
      },
      immediate: true,
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get('/top-categories');
        this.categoryData = response.data.rows.map((item) => ({
          cat_id: item.cat_id,
          cat_name: item.cat_name,
          product_count:0, // Assuming `products` contains the product list
        }));
        console.log(this.categoryData);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    handleCategoryRoute(value) {
      const newCategory = formatUrl(value);
      this.$router.push(`/shop?category=${newCategory}`);
    },
  },
  mounted() {
    this.activeQuery = this.$route.query.category;
    this.fetchCategories(); // Fetch categories when the component is mounted
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
